import { BiCameraMovie, BiChart, BiCloudDownload, BiCode, BiCodeAlt, BiColorFill, BiCrop, BiCut, BiImageAlt, BiLink, BiMessageSquare, BiMessageSquareDetail, BiTimeFive, BiTrendingUp } from 'react-icons/bi';
import { FaChartLine, FaCogs, FaDatabase, FaFileAlt, FaFilm, FaGraduationCap, FaPalette, FaPencilRuler, FaPhotoVideo, FaRegClock, FaSearch, FaTools, FaUserSecret, FaVideo } from 'react-icons/fa';
import { MdAppShortcut, MdManageSearch, MdOutlineDataExploration, MdOutlineQueryStats, MdSecurity } from 'react-icons/md';
import { BsDatabase, BsHeadphones, BsShieldLock } from 'react-icons/bs';
import { CiSettings } from 'react-icons/ci';
import appImg from './service/service-img-4.jpg';
import webImg from './service/service-feature-img.jpg';
import seoImg from './service/service-img-3.jpg';
import scrapingImg from './service/service-img-2.jpg';
import videoImg from './service/service-img-5.jpg';
import designImg from './service/service-img-6.jpg';


const serviceList = [
  {
    title: 'Mobile App Development',
    slug: 'mobile-app-development',
    herotitle: {
      start: 'Build fast, scale smarter with',
      highlight: 'mobile apps',
    },
    heroSubtitle: 'Empowering your vision through agile and future-ready mobile solutions.',

    description:
      'Native and cross-platform mobile apps designed for seamless user experiences across iOS and Android.',
    image: appImg,

    whytitle: 'Transforming [[Ideas into]] Scalable Apps',
    description1:
      'We build powerful mobile applications that are not only visually stunning but also engineered for performance, security, and user engagement. Our solutions are designed to adapt to real-world user behavior, integrate seamlessly with backend systems, and scale with your business without compromising on quality or speed.',
    description2:
      'At AppNexts, we transform your product vision into reality through agile development, cutting-edge technologies, and collaborative design thinking. Whether it’s a startup MVP or a complex enterprise-grade app, our teams ensure every project is built to last, evolve continuously, and deliver real business impact.',
    stats: [
      {
        icon: MdAppShortcut,
        title: 'Faster MVP Launch',
        description: 'Accelerate time-to-market with 70% of MVPs delivered within 12 weeks using agile sprints and lean methodologies.',
      },
      {
        icon: BiTrendingUp,
        title: 'Built for Scale',
        description: 'Scalable codebases and modular architecture to handle growing traffic, features, and markets effortlessly.',
      },
      {
        icon: FaUserSecret,
        title: 'UX That Converts',
        description: 'Intuitive, user-first interfaces that boost engagement and retention by over 30% across platforms.',
      },
      {
        icon: BiMessageSquare,
        title: 'Dedicated Support',
        description: 'Round-the-clock technical assistance with proactive monitoring and rapid issue resolution.',
      },
    ],


    features: [
  {
    icon: BiCode,
    title: 'Digital Transformation Services',
    description:
      'We deliver mobile solutions that align with your digital transformation roadmap—leveraging secure, scalable architectures, cloud integration, and emerging technologies to modernize business workflows and customer experiences.',
  },
  {
    icon: FaUserSecret,
    title: 'Resource Augmentation',
    description:
      'Need to scale quickly? We provide on-demand access to experienced mobile developers, UI/UX designers, and QA engineers who seamlessly integrate into your team, accelerating development without compromising quality.',
  },
  {
    icon: BsHeadphones,
    title: '24/7 Support & Maintenance',
    description:
      'Beyond launch, we ensure your app remains fast, secure, and updated. Our support includes real-time monitoring, performance tuning, issue resolution, and version updates across Android and iOS platforms.',
  },
  {
    icon: BsDatabase,
    title: 'App Migration & Optimization',
    description:
      'Migrate legacy apps to modern frameworks like Flutter or React Native, or optimize your existing app with improved UI, better performance, and scalable backend systems—future-proofing your investment.',
  },
  {
    icon: FaGraduationCap,
    title: 'App Training & Onboarding',
    description:
      'We provide comprehensive training and documentation to onboard your internal teams—empowering them to manage, update, and scale the app independently post-launch with confidence.',
  },
  {
    icon: CiSettings,
    title: 'Custom Integrations & APIs',
    description:
      'From payment gateways and CRMs to analytics and IoT systems, we build and integrate secure, scalable APIs that connect your app to the tools and platforms you rely on—enabling automation and data flow.',
  },
],



    seotitle: "Custom Mobile App Development Services | AppNexts",
    seodescription:
      "Build robust and scalable mobile apps for Android and iOS with AppNexts. Expert mobile app development tailored to your business needs and user engagement.",
    seoKeywords: [
      'mobile app development',
      'custom mobile apps',
      'Android app development',
      'iOS app development',
      'cross-platform mobile apps',
      'mobile UX/UI design',
      'React Native development',
      'Flutter mobile apps',
      'app maintenance services',
      'AppNexts',
    ],
  },

  {
    title: 'Website Development',
    slug: 'website-development',
    herotitle: {
      start: 'Future-proof',
      highlight: 'website development',
    },
    heroSubtitle: 'Creating fast, responsive, and SEO-optimized websites that convert and scale with your business.',
    description: 'Custom, responsive websites built with modern frameworks for seamless performance across all devices.',
    image: webImg,
    whytitle: 'Engineering [[Web Experiences]] that Convert',
    description1: 'We specialize in building robust, modern websites that blend aesthetic design with powerful functionality. Our development approach ensures each website is fast, mobile-responsive, SEO-friendly, and aligned with your business objectives.',
    description2: 'At AppNexts, our cross-functional team leverages the latest technologies and agile workflows to build websites that are secure, scalable, and performance-optimized — enabling long-term digital growth.',
    stats: [
      {
        icon: BiTrendingUp,
        title: 'SEO-Ready Architecture',
        description: 'Structured for visibility with semantic HTML, speed, and schema integration.',
      },
      {
        icon: BiCode,
        title: 'Custom Codebase',
        description: 'Tailored development with clean, scalable code across modern frameworks.',
      },
      {
        icon: FaUserSecret,
        title: 'User-Centric UX',
        description: 'Intuitive, responsive interfaces designed for high engagement and retention.',
      },
      {
        icon: BiMessageSquare,
        title: 'Ongoing Support',
        description: 'Post-launch updates, performance monitoring, and bug resolution.',
      },
    ],
    features: [
  {
    icon: BiCode,
    title: 'Responsive Web Design',
    description:
      'We design mobile-first, fully responsive websites that adapt seamlessly across all devices—offering users a consistent and engaging experience whether they’re browsing on desktops, tablets, or smartphones.',
  },
  {
    icon: FaUserSecret,
    title: 'Custom Development',
    description:
      'From simple business sites to complex web portals, we build tailored solutions using modern frameworks like React, Next.js, or Laravel to align with your business logic and growth needs.',
  },
  {
    icon: BsHeadphones,
    title: 'Ongoing Support & Maintenance',
    description:
      'Post-launch, we ensure your website remains secure, fast, and bug-free with regular updates, content optimization, and 24/7 technical support to keep everything running smoothly.',
  },
  {
    icon: BsDatabase,
    title: 'CMS Integration',
    description:
      'Easily manage and update your site content with seamless CMS integration—whether it’s WordPress, Strapi, Sanity, or a custom headless CMS solution that gives you full control.',
  },
  {
    icon: FaGraduationCap,
    title: 'SEO & Performance Optimization',
    description:
      'Our websites are optimized for search engines and speed from day one, with clean code, fast load times, mobile performance, and structured data implementation for maximum visibility.',
  },
  {
    icon: CiSettings,
    title: 'Third-party API & Tool Integration',
    description:
      'We connect your website to essential third-party platforms like CRMs, analytics, marketing automation tools, or payment gateways—enabling seamless operations and data flow.',
  },
],



     seotitle:"Responsive Website Design & Development | Appnexts",
      seodescription:"Get custom website development services with responsive design and scalable solutions. We build websites using React.js, Laravel, WordPress, and more to boost your business online.",
         seoKeywords: [
      'website development',
      'responsive website design',
      'custom web applications',
      'React.js development',
      'Laravel web development',
      'WordPress websites',
      'scalable websites',
      'professional web development',
      'business websites',
      'AppNexts',
    ],
  },
  {
  title: 'SEO Services',
  slug: 'seo-services',
  herotitle: {
    start: 'Data-driven',
    highlight: 'SEO strategies',
  },
  heroSubtitle:
    'Maximize digital reach with search-optimized content, technical expertise, and continuous performance tracking.',
  description:
    'AppNexts drives sustainable organic growth through technical SEO, content strategy, and performance-based optimization.',
  image: seoImg, // Make sure this image is defined/imported
  whytitle: 'Driving [[Traffic That Converts]]',
 description1:
  'We deliver end-to-end SEO solutions — from keyword research and on-page optimization to backlink building and technical audits — ensuring your brand ranks higher, faster, and longer. Our data-driven approach uncovers new traffic opportunities, enhances site visibility, and aligns perfectly with search engine algorithms. From startups to enterprises, we tailor strategies that evolve with your goals.',
 description2:
  'AppNexts takes a holistic, algorithm-friendly approach to search engine visibility, focusing on ROI and long-term authority in your industry niche. We prioritize sustainable SEO practices, combining content excellence with technical precision. By continuously monitoring trends and updates, we future-proof your rankings and keep your site ahead of the competition.',

  stats: [
    {
      icon: BiTrendingUp,
      title: 'Keyword Ranking Growth',
      description: 'Top 5 keyword positions achieved in 90% of SEO campaigns within 6 months.',
    },
    {
      icon: MdOutlineQueryStats,
      title: 'Technical SEO',
      description: 'Site speed, structured data, mobile-first indexing—optimized from the core.',
    },
    {
      icon: FaChartLine,
      title: 'Traffic Increase',
      description: 'Clients see up to 200% organic traffic growth within the first year.',
    },
    {
      icon: BiMessageSquareDetail,
      title: 'Content Strategy',
      description: 'SEO-driven content plans that match search intent and boost engagement.',
    },
  ],

  features: [
  {
    icon: BiCodeAlt,
    title: 'Technical Site Audits',
    description:
      'In-depth audits to uncover crawl issues, site architecture problems, page speed bottlenecks, and indexing barriers—ensuring your website is optimized for peak search engine performance.',
  },
  {
    icon: FaSearch,
    title: 'Keyword & Competitor Analysis',
    description:
      'We perform deep keyword research and competitor benchmarking to uncover high-converting terms and content gaps, giving your SEO strategy a competitive edge.',
  },
  {
    icon: BiLink,
    title: 'Link Building & Outreach',
    description:
      'Earn high-quality, authoritative backlinks through ethical white-hat strategies, guest posting, and targeted outreach that boosts domain authority and trust.',
  },
  {
    icon: FaFileAlt,
    title: 'Content SEO',
    description:
      'Create search-optimized, engaging content that aligns with user intent and algorithm preferences—driving traffic, engagement, and improved SERP rankings.',
  },
  {
    icon: MdManageSearch,
    title: 'On-Page Optimization',
    description:
      'Comprehensive on-page improvements including meta tags, structured data, image alt texts, and internal linking to maximize search visibility and usability.',
  },
  {
    icon: CiSettings,
    title: 'Analytics & Reporting',
    description:
      'Track progress with detailed monthly reports covering keyword rankings, traffic insights, conversion metrics, and actionable recommendations.',
  },
],


  seotitle: "Expert SEO Services to Boost Your Online Visibility | AppNexts",
  seodescription: "Drive organic traffic and improve search engine rankings with AppNexts SEO services. Comprehensive strategies tailored to grow your business online.",
  seoKeywords: [
    'SEO services',
    'keyword research',
    'on-page SEO',
    'technical SEO',
    'SEO audits',
    'content strategy',
    'organic traffic',
    'search engine optimization',
    'AppNexts',
  ],
},
  {
  title: 'Data Scraping Services',
  slug: 'data-scraping',
  herotitle: {
    start: 'Automated',
    highlight: 'Data Scraping',
  },
  heroSubtitle: 'Unlock web data at scale for insights, automation, and business growth.',
  description: 'We build fast, accurate web scrapers and APIs that extract structured data from any website or platform at scale.',
  image: scrapingImg, // replace with your actual image path
  whytitle: 'Extracting [[Valuable Web Data]] at Scale',
  description1:
  'Our scraping solutions allow businesses to collect, normalize, and utilize massive amounts of publicly available data from ecommerce, finance, travel, real estate, and more. We help you turn raw web data into structured insights for smarter decision-making and competitive analysis.',

description2:
  'AppNexts delivers resilient, scalable data pipelines using anti-blocking mechanisms, rotating proxies, and intelligent parsing, ensuring your data arrives clean and fast. Our systems are built to handle high-volume extraction while maintaining accuracy, compliance, and performance across diverse data sources.',

  stats: [
    {
      icon: BiCodeAlt,
      title: 'Fast Scraper Deployment',
      description: 'Custom scrapers delivered in under 5 days for most use cases.',
    },
    {
      icon: FaDatabase,
      title: 'Scalable Architecture',
      description: 'Handles millions of pages per month using distributed scraping nodes.',
    },
    {
      icon: MdSecurity,
      title: 'Anti-blocking Strategies',
      description: 'Evade captchas and blocks using smart retries, user-agent spoofing, and proxy rotation.',
    },
    {
      icon: BiChart,
      title: 'Structured Outputs',
      description: 'Clean CSV, JSON, or database-ready formats for seamless integration.',
    },
  ],
   features: [
  {
    icon: BiCloudDownload,
    title: 'Web Scraping Bots',
    description: 'Automated bots to extract product listings, reviews, pricing data, and more across thousands of web pages—built for scale, speed, and accuracy.',
  },
  {
    icon: FaCogs,
    title: 'Custom API Integration',
    description: 'Deliver structured, real-time scraped data directly into your backend systems, CRMs, or analytics dashboards via secure and scalable custom APIs.',
  },
  {
    icon: MdOutlineDataExploration,
    title: 'Real-Time Data Extraction',
    description: 'Ideal for time-sensitive use cases such as dynamic pricing, stock availability updates, or event-based tracking with minimal latency.',
  },
  {
    icon: BsShieldLock,
    title: 'Ethical Compliance',
    description: 'We strictly follow ethical and legal best practices, ensuring scraping activities are non-intrusive, compliant, and respect robots.txt guidelines.',
  },
  {
    icon: FaRegClock,
    title: 'Scheduled & Automated Runs',
    description: 'Configure scraping jobs to run hourly, daily, or weekly—fully automated to fit your operational workflows and data refresh needs.',
  },
  {
    icon: CiSettings,
    title: 'Post-Processing & Cleaning',
    description: 'Transform raw data into actionable insights by removing duplicates, fixing formats, validating fields, and ensuring high-quality structured output.',
  },
],

  seotitle: "Professional Data Scraping Services for Accurate Business Intelligence | AppNexts",
  seodescription: "Get precise and automated data scraping solutions from AppNexts. Collect, clean, and analyze large data volumes to drive business insights and support AI initiatives.",
  seoKeywords: [
    'data scraping',
    'web scraping',
    'automated data collection',
    'data extraction',
    'business intelligence',
    'machine learning data',
    'AI data',
    'data cleaning',
    'market analysis',
    'AppNexts',
  ],
},
{
  title: 'Video Editing',
  slug: 'video-editing',
  herotitle: {
    start: 'Creative',
    highlight: 'Video Editing',
  },
  heroSubtitle: 'Engage your audience with professionally crafted visuals, effects, and storytelling.',
  description: 'AppNexts delivers powerful video editing solutions for brands, influencers, and businesses. From YouTube intros to corporate promos, we turn raw footage into cinematic experiences.',
  image: videoImg,
  whytitle: 'Crafting [[Stories that Connect]] with Audiences',
 description1: 'We bring videos to life with seamless editing, dynamic transitions, and brand-aligned aesthetics to keep your viewers engaged from start to finish. From promotional content to social media reels and corporate explainers, every frame is optimized for impact.',
description2: 'With expert editors, fast turnaround times, and multi-format exports, AppNexts ensures your video content drives results across platforms. Our team blends creativity with strategy, delivering polished, platform-ready videos that resonate with your target audience.',
 stats: [
    {
      icon: BiCameraMovie,
      title: '200+ Projects Delivered',
      description: 'Trusted by creators and brands for consistent, high-quality edits.',
    },
    {
      icon: BiCut,
      title: 'Creative Storytelling',
      description: 'Each cut, transition, and frame is designed to enhance message clarity.',
    },
    {
      icon: FaTools,
      title: 'Advanced Editing Tools',
      description: 'From color grading to VFX, we use pro software for polished results.',
    },
    {
      icon: BiTimeFive,
      title: 'Fast Turnaround',
      description: 'Edits delivered within 3-5 business days for most projects.',
    },
  ],
  features: [
  {
    icon: FaVideo,
    title: 'Promo & Commercial Editing',
    description: 'Short, high-impact promotional videos crafted to boost audience retention, brand recall, and conversions across marketing channels.',
  },
  {
    icon: FaFilm,
    title: 'Social Media Edits',
    description: 'Platform-optimized reels, TikToks, and YouTube Shorts with trendy transitions, sound effects, and fast-paced edits designed to go viral.',
  },
  {
    icon: BiCut,
    title: 'Corporate Videos',
    description: 'Professional post-production for training sessions, onboarding walkthroughs, internal communications, and executive presentations.',
  },
  {
    icon: FaTools,
    title: 'Color Grading & Audio Sync',
    description: 'Refine visuals and audio with cinematic color grading, precise audio leveling, and lip-sync accuracy for a polished final product.',
  },
  {
    icon: CiSettings,
    title: 'Custom Motion Graphics',
    description: 'Add visual flair with animated logos, branded intros, lower thirds, kinetic typography, and explainer-style animations.',
  },
  {
    icon: BiTimeFive,
    title: 'Multi-format Delivery',
    description: 'Videos exported in multiple resolutions and aspect ratios, optimized for HD displays, mobile devices, and web platforms.',
  },
],

  seotitle: "Professional Video Editing Services | Engaging & Polished Videos | AppNexts",
  seodescription: "Transform your raw footage into captivating, high-quality videos with AppNexts’ expert video editing services. Perfect for promotional, corporate, and social media content.",
  seoKeywords: [
    'video editing',
    'professional video editing',
    'promotional videos',
    'corporate video editing',
    'social media video editing',
    'video effects',
    'color grading',
    'sound design',
    'motion graphics',
    'AppNexts',
  ],
},

{
  title: 'Graphics Design',
  slug: 'graphics-design',
  herotitle: {
    start: 'Visually Striking',
    highlight: 'Graphic Design',
  },
   heroSubtitle: 'Creative visuals that elevate your brand identity across platforms.',
  description: 'AppNexts delivers captivating graphic design services to businesses, startups, and agencies. From logos and banners to full brand kits, we blend creativity and strategy for lasting impressions.',
  image: designImg,
  whytitle: 'Designing [[Visual Stories]] That Inspire',
 description1:
  'Our graphic designers craft compelling visuals that align with your brand voice and captivate your audience. Whether it’s web, print, or social media, we ensure consistent, creative, and high-impact delivery that drives recognition and engagement.',
description2:
  'With a user-first approach, we balance aesthetics and usability to create designs that not only look great but also convert and engage across all touchpoints. From wireframes to polished creatives, we bring your visual identity to life with clarity and purpose.',
 stats: [
    {
      icon: FaPencilRuler,
      title: '200+ Designs Delivered',
      description: 'From logo concepts to social media creatives, with client satisfaction.',
    },
    {
      icon: BiColorFill,
      title: 'Brand Consistency',
      description: 'Design systems and kits to keep your brand identity aligned across platforms.',
    },
    {
      icon: FaPalette,
      title: 'Creative Excellence',
      description: 'Custom visuals built with attention to color theory, typography, and layout.',
    },
    {
      icon: FaPhotoVideo,
      title: 'Multimedia Design',
      description: 'Assets designed for web, print, ads, social media, and more.',
    },
  ],
  features: [
  {
    icon: BiImageAlt,
    title: 'Logo & Branding',
    description:
      'Distinctive logo design and complete branding kits that capture your brand’s personality and make a memorable impression across all platforms.',
  },
  {
    icon: FaPencilRuler,
    title: 'UI/UX Design Assets',
    description:
      'High-fidelity icons, illustrations, buttons, and interface elements customized for mobile apps, SaaS dashboards, and websites.',
  },
  {
    icon: BiCrop,
    title: 'Social Media Creatives',
    description:
      'Scroll-stopping visuals for posts, carousels, ads, and stories—perfectly sized and styled for Instagram, Facebook, LinkedIn, and more.',
  },
  {
    icon: CiSettings,
    title: 'Custom Illustrations',
    description:
      'Tailored vector graphics and hand-crafted illustrations that elevate visual storytelling and enhance brand identity.',
  },
  {
    icon: FaPhotoVideo,
    title: 'Print-Ready Materials',
    description:
      'Designs for brochures, flyers, business cards, and packaging—optimized with CMYK colors and bleed margins for professional printing.',
  },
  {
    icon: BiColorFill,
    title: 'Design Systems',
    description:
      'Scalable, reusable component libraries and brand guidelines built to ensure consistency across every touchpoint and future design asset.',
  },
],

 seotitle: "Creative Graphic Design Services | Branding & Visual Identity | AppNexts",
  seodescription: "Stand out with AppNexts' professional graphic design services. We craft compelling logos, branding, and marketing visuals tailored to your business identity and goals.",
  seoKeywords: [
    'graphic design',
    'branding design',
    'visual identity',
    'logo design',
    'brochure design',
    'social media graphics',
    'UI/UX design',
    'marketing materials design',
    'AppNexts',
    'creative graphic services',
  ],
},


];

export default serviceList;
